import { useState } from 'react'
import WelCome from './NewWeddingModal/WelCome'

const OnBoardingKazoo = () => {
	const [open, setOpen] = useState(false)
	const [step, setStep] = useState(0)

	const handleNext = () => {
		if (step === steps.length - 1) {
			handleClose()
		} else {
			setStep((prev) => prev + 1)
		}
	}

	const handleClose = () => {
		setOpen(false)
		setStep(0)
	}
	const steps = [
		<WelCome
			handleNext={handleNext}
			open={open && step === 0}
			handleClose={handleClose}
		/>,
	]

	return <>{steps[step]}</>
}
export default OnBoardingKazoo
